module.exports = __webpack_public_path__ + "img/jichuang.50307194.jpg";